<template>
  <!-- 已发布商品 alreadyRelease -->
  <pack>
    <zt-title>
      已发布商品
      <zt-button
        slot="after"
        type="primary"
        @click="dialogLinkVisible=true"
        size="medium"
        icon="el-icon-plus"
      >添加</zt-button>
    </zt-title>

    <!-- 检索器 -->
    <el-form @submit.native.prevent class="seeker mt24" label-width="60px" label-position="left">
      <el-form-item label="频道：" size="medium">
        <el-radio-group v-model="seeker.channel">
          <el-radio-button label>全部</el-radio-button>
          <el-radio-button :label="0">九块九</el-radio-button>
          <el-radio-button :label="1">人工精选</el-radio-button>
          <el-radio-button :label="3">限时抢购</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="来源：" size="medium">
        <radio-checked :model.sync="fromModel">
          <template slot="checkbox">
            <el-checkbox-button label="dataoke">大淘客</el-checkbox-button>
            <el-checkbox-button label="smzdm">什么值得买</el-checkbox-button>
            <el-checkbox-button label="baicaio">白菜哦</el-checkbox-button>
          </template>
        </radio-checked>
      </el-form-item>-->

      <el-form-item label="类型：">
        <el-checkbox-group v-model="typeModel" size="medium">
          <el-checkbox label="item_taoqiangou">淘抢购</el-checkbox>
          <el-checkbox label="item_juhuasuan">聚划算</el-checkbox>
          <el-checkbox label="is_gold">金牌商家</el-checkbox>
          <el-checkbox label="is_tmall">天猫商家</el-checkbox>
          <el-checkbox label="item_freight_insurance">运费险</el-checkbox>
          <el-checkbox label="item_has_videos">视频</el-checkbox>
          <el-checkbox label="zengpin">抽纸单</el-checkbox>
          <el-checkbox label="coupon_long">长时效</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="排序：">
        <zt-input class="prefix-select pd mr8" width="190px" size="medium">
          <zt-button slot="prepend" width="100px" size="medium">类型</zt-button>
          <el-select
            v-model="orderTypeModel"
            @change="changeOrderType"
            slot="append"
            clearable
            placeholder="请选择"
          >
            <el-option label="添加时间" value="add_time"></el-option>
            <el-option label="销量" value="item_salenum"></el-option>
            <el-option label="佣金比例" value="max_commission_rate"></el-option>
            <!-- <el-option label="热度" value="hot"></el-option> -->
          </el-select>
        </zt-input>

        <zt-input class="prefix-select pd mr8" width="190px" size="medium">
          <zt-button slot="prepend" width="100px" size="medium">顺序</zt-button>
          <el-select
            v-model="orderModel"
            @change="changeOrder"
            slot="append"
            clearable
            placeholder="请选择"
          >
            <el-option label="从高到低" value="DESC"></el-option>
            <el-option label="从低到高" value="ASC"></el-option>
          </el-select>
        </zt-input>
      </el-form-item>

      <el-form-item label="场次：" v-if="seeker.channel == 3">
        <el-date-picker v-model="flashsaledate" value-format="yyyy-MM-dd" placeholder="选择日期" />
        <el-select class="ml8" v-model="flashsaletime" placeholder="选择场次">
          <template v-for="o of flashsaletimes">
            <el-option :label="o" :value="o" :key="o" />
          </template>
        </el-select>
      </el-form-item>

      <el-form-item label="日期: ">
        <el-date-picker
          v-model="timeModel"
          @change="changeTime"
          type="daterange"
          range-separator="至"
          start-placeholder="采集开始时间"
          end-placeholder="采集结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00','23:59:59']"
          :picker-options="datePickerOpt"
          size="medium"
        />
      </el-form-item>

      <el-form-item label="搜索：">
        <zt-input
          v-model.trim="seeker.item_brand"
          width="350px"
          placeholder="请输入品牌"
          size="medium"
          clearable
          class="mr5"
        >
          <template slot="prepend">品牌</template>
        </zt-input>
        <zt-input
          v-model.trim="seeker.item_iid"
          width="350px"
          placeholder="请输入淘宝ID"
          size="medium"
          clearable
          class="mr5"
        >
          <template slot="prepend">淘宝ID</template>
        </zt-input>
        <zt-input
          v-model.trim="seeker.item_name"
          placeholder="请输入商品名称"
          size="medium"
          clearable
          width="350px"
          class="mr5"
        >
          <template slot="prepend">商品名称</template>
        </zt-input>
        <zt-input
          v-model.trim="seeker.max_commission_rate_from"
          placeholder="请输入金额"
          size="medium"
          clearable
          width="350px"
        >
          <template slot="prepend">佣金大于</template>
        </zt-input>
      </el-form-item>

      <el-form-item label=" ">
        <zt-button size="medium" type="primary" native-type="submit" icon="el-icon-search" @click.enter.exact="onSeeker">搜索</zt-button>
        <zt-button size="medium" icon="el-icon-delete" class="ml10" @click="onClearSeek">清空</zt-button>
      </el-form-item>
    </el-form>

    <!-- 控制条 -->
    <div class="control-bar mb8 mt16">
      <zt-button
        @click="sbtDel(tableSelectedID.join(','))"
        class="ml8"
        size="small"
        :disabled="!tableSelectedID.length"
        icon="el-icon-delete"
      >下架</zt-button>
    </div>

    <!-- 表 -->
    <el-table
      :data="table"
      ref="table"
      @selection-change="onSelectionChange"
      v-loading="tableLoading"
    >
      <el-table-column label="排序" min-width="50">
        <template slot-scope="{ row }">{{ row.channel.length ? toOrderID(row.channel, 1) : '-'}}</template>
      </el-table-column>

      <el-table-column type="selection" width="30" fixed="left"></el-table-column>
      <el-table-column label="淘宝ID" min-width="130">
        <template slot-scope="{ row }">
          <p>{{ row.item_id}}</p>
          <p>{{ row.add_time}}</p>
        </template>
      </el-table-column>

      <el-table-column label="频道" min-width="70">
        <template slot-scope="{ row }">
          <p>{{ channel2cn(row.channel,row.item_price) }}</p>
        </template>
      </el-table-column>

      <el-table-column label="推荐" min-width="40">
        <template slot-scope="{ row }">
          <p>{{ row.item_id && '无'}}</p>
        </template>
      </el-table-column>

      <el-table-column label="商品名称" min-width="166">
        <template slot-scope="{ row }">
          <el-tooltip effect="dark" placement="bottom">
            <!-- 文案 -->
            <emoji-parse
              v-if="row.item_ad"
              class="content"
              slot="content"
              :content="$adFormat.ader2br(row.item_ad)"
            ></emoji-parse>
            <div v-else class="content placeholder" slot="content">暂无相关文案，可进入编辑页面添加</div>
            <!-- 淘宝链接/商品名称 -->
            <app-link :to="row.taobao_url">{{row.item_name}}</app-link>
          </el-tooltip>
          <!-- <p>{{row.item_promise}}</p> -->
          <p class="icons">
            <sprite-icon v-if="row.item_shop_certtext === '金牌卖家'" icon="jinpaimaijia"></sprite-icon>
            <sprite-icon v-if="row.item_freight_insurance" icon="tuihuoxian"></sprite-icon>
            <sprite-icon v-if="row.item_juhuasuan" icon="juhuasuan"></sprite-icon>
            <sprite-icon v-if="row.item_taoqiangou" icon="taoqianggou"></sprite-icon>
            <sprite-icon v-if="row.item_zengpin" icon="zengpin"></sprite-icon>
          </p>
        </template>
      </el-table-column>

      <el-table-column label="图" min-width="132">
        <div class="main-img" slot-scope="{ row }">
          <img v-if="row.pict_url" :src="row.pict_url" />
          <span v-else>-</span>
        </div>
      </el-table-column>
      <el-table-column label="价格信息" min-width="130">
        <template slot-scope="{ row }">
          <p>原价：{{row.item_discount_price | formatEmpty}}</p>
          <p>劵后：{{row.item_price | formatEmpty}}</p>
          <p>比率：{{row.max_commission_rate | formatRatio | formatEmpty}}</p>
        </template>
      </el-table-column>
      <el-table-column label="劵信息" min-width="160">
        <template slot-scope="{ row }">
          <p>剩余量: {{ row.coupon_remain_count | formatPercentum(row.coupon_total_count) | formatEmpty }}</p>
          <p>开始: {{ row.coupon_start_time || '-' }}</p>
          <p>结束: {{ row.coupon_end_time || '-' }}</p>
          <p>面额: {{ row.coupon_price || '-' }}</p>
        </template>
      </el-table-column>
      <el-table-column label="销量" min-width="60">
        <template slot-scope="{ row }">{{row.item_salenum | formatEmpty('0')}}</template>
      </el-table-column>

      <!-- <el-table-column label="热度" min-width="40">
        <template slot-scope="{ row }">
          <p>{{ row.hot}}</p>
        </template>
      </el-table-column>-->

      <el-table-column label="来源">
        <template slot-scope="{ row }">{{row.type | formatSource | formatEmpty}}</template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="90px">
        <template slot-scope="{ row }">
          <zt-button
            @click="onChannelOrder(row)"
            size="mini"
            width="80px"
            class="mb10"
            :disabled="(channel2cn(row.channel,row.item_price) == '九块九')"
          >修改排序</zt-button>
          <app-link :to="`/pk-edit/edit?mode=already&id=${row.id}&type='已发布商品'`">
            <zt-button size="mini" width="80px" class="mb10">编辑</zt-button>
          </app-link>
          <zt-button size="mini" width="80px" @click="sbtDel(row.id)">下架</zt-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordcount"
        :page-size="pagesize"
      />
    </div>

    <!-- dialog - 添加链接 -->
    <dialog-link width="440px" :visible.sync="dialogLinkVisible" />

    <dialog-channel-order ref="dialogChannelOrder" @submit="getList()" />
  </pack>
</template>

<script>
import releaseBase from './mixins/releaseBase';
import { admin_items_list, admin_items_delete } from '@/api/pkEdit';
import dialogChannelOrder from './components/dialogChannelOrder';
import { sleep } from '@/utils/timer';
import EmojiParse from '@cps/EmojiEditor/EmojiParse';

export default {
  name: 'pkEditAlreadyRelease',
  components: {
    dialogChannelOrder,
    EmojiParse,
  },
  mixins: [releaseBase],
  data: () => ({
    // table
    tableField: {
      item_id: '', // 淘宝ID
      channel: '', // 频道
      hot: '', // 热度
      add_time: '', // 添加时间
      item_name: '', // 商品名称
      item_brand: '', // 品牌名称
      item_promise: '', // icon-cn
      pict_url: '', // 主图
      item_discount_price: '', // 原价
      item_price: '', // 劵后
      max_commission_rate: '', // 比率
      coupon_remain_count: '', // 优惠券剩余
      coupon_total_count: '', // 优惠券总量
      coupon_start_time: '', // 优惠券开始时间
      coupon_end_time: '', // 优惠券开始时间
      item_salenum: '', // 销量
      type: '', // 来源: dataoke大淘客 smzdm什么值得买 baicaio 白菜哦 cqp 酷Q
    },

    // 分页器
    page: 1,
    pagesize: 10,
    recordcount: 10,

    flashsaledate: '',
    flashsaletime: '',
    flashsaletimes: [
      '00:00',
      '09:00',
      '10:00',
      '12:00',
      '15:00',
      '17:00',
      '20:00',
    ],
  }),
  watch: {
    'seeker.item_iid'(val) {
      if (val.indexOf(' ') !== -1) {
        this.seeker.item_iid = this.seeker.item_iid.replace(/\s+/g, '');
      }
    },
  },
  methods: {
    //search
    search() {
      this.page = 1
      this.getList()
    },
    // 获取 - 列表
    getList() {
      this.seeker.order = [this.orderTypeModel, this.orderModel].join(' ');
      let seekerType = this.toSeekerType(this.typeModel);
      this.tableLoading = true;
      sleep(() => {
        // 限时抢购
        const show_time =
          this.seeker.channel == 3 && this.flashsaledate && this.flashsaletime
            ? this.flashsaledate + ' ' + this.flashsaletime
            : '';

        admin_items_list({
          ...this.seeker,
          ...seekerType,
          show_time,
          page: this.page,
          pagesize: this.pagesize,
        }).then(({ data }) => {
          this.tableLoading = false;
          let { error_code, error_message } = data;
          if (error_code == 0) {
            this.table = data.list;
            this.recordcount = data.recordcount;
          } else {
            this.$message.error(error_message);
          }
        });
      }, 250);
    },

    // 修改排序
    onChannelOrder(row) {
      this.$refs.dialogChannelOrder.open(row);
    },

    // 提交 - 删除商品
    sbtDel(id) {
      let blacklist = 0; // 是否拉黑
      const h = this.$createElement;

      this.$msgbox({
        title: '消息',
        message: h('div', { key: Date.now() }, [
          h('p', null, ['是否下架商品?']),
          h('p', null, [
            h(
              'el-checkbox',
              {
                domProps: {
                  value: 0,
                },
                props: {
                  trueLabel: 1,
                  falseLabel: 0,
                },
                on: {
                  input: (val) => {
                    blacklist = val;
                  },
                },
                style: {
                  color: '#8D9299',
                },
              },
              ['同时拉入黑名单,不再自动拉取?']
            ),
          ]),
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          done();
          console.log(instance);

          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            admin_items_delete({ id, blacklist }).then(({ data }) => {
              let { error_code, error_message } = data;
              if (error_code == 0) {
                this.$message.success('下架商品成功');
                this.getList();
              } else {
                this.$message.error(error_message);
              }
              instance.confirmButtonLoading = false;
              done();
            });
          } else {
            done();
          }
        },
      });
    },

    // 清空搜索
    onClearSeek() {
      this.seeker.channel = '';
      this.seeker.item_name = '';
      this.fromModel = [''];
      this.typeModel = [];
      this.orderTypeModel = '';
      this.orderModel = '';
      this.timeModel = '';
      this.seeker.item_iid = '';
      this.seeker.item_brand = '';
      this.flashsaledate = '';
      this.flashsaletime = '';
      this.getList();
    },

    // 根据chanel获取排序号
    toOrderID(channel, channel_id) {
      const chl = channel.find((item) => item.channel_id == channel_id) || {};

      return chl.order_id || '无';
    },
  },
  created() {
    if (this.$store.state.search.item_id != 0) {
      this.seeker.item_iid = this.$store.state.search.item_id;
    }
    this.getList();
    this.$store.commit('SEARCH_GOODS', 0);
  },
  activated() {
    if (this.$store.state.search.item_id != 0) {
      this.seeker.item_iid = this.$store.state.search.item_id;
    }
    // 页面刷新数据,未修改
    this.getList();
    this.$store.commit('SEARCH_GOODS', 0);
  },
};
</script>

<style lang="scss" scoped>
@import "./mixins/releaseBase.scss";
/deep/ .prefix-select {
  overflow: hidden;
}
</style>
